import { render, staticRenderFns } from "./BaseFieldLink.vue?vue&type=template&id=a51727ce&scoped=true"
import script from "./BaseFieldLink.vue?vue&type=script&lang=js"
export * from "./BaseFieldLink.vue?vue&type=script&lang=js"
import style0 from "./BaseFieldLink.vue?vue&type=style&index=0&id=a51727ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51727ce",
  null
  
)

export default component.exports